module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/large.0b2d23c1d5c2421aa46c.jpg";